import { render, staticRenderFns } from "./resultCardContent.vue?vue&type=template&id=0c3075c7&"
import script from "./resultCardContent.vue?vue&type=script&lang=ts&"
export * from "./resultCardContent.vue?vue&type=script&lang=ts&"
import style0 from "./resultCardContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports